/* Duinadem — dn-ui.js
   Scroll-animaties, review-slider en review-video's. Geen externe libraries. */
(function () {
  'use strict';
  if (window.__dnUi) return; // script kan door meerdere secties geladen worden
  window.__dnUi = true;

  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px' });
  }

  function initReveal(root) {
    root.querySelectorAll('.dn-reveal:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }

  function initSlider(slider) {
    if (slider.dataset.dnReady) return;
    slider.dataset.dnReady = '1';
    var track = slider.querySelector('.dn-slider__track');
    var prev = slider.querySelector('.dn-slider__nav--prev');
    var next = slider.querySelector('.dn-slider__nav--next');
    if (!track) return;

    function step() {
      var first = track.firstElementChild;
      return first ? first.getBoundingClientRect().width + 18 : track.clientWidth;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth - 2;
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft >= max;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function initVideos(root) {
    root.querySelectorAll('[data-dn-play]').forEach(function (btn) {
      if (btn.dataset.dnReady) return;
      btn.dataset.dnReady = '1';
      var video = btn.parentElement.querySelector('video');
      if (!video) return;
      btn.addEventListener('click', function () {
        if (video.muted) {
          video.muted = false;
          video.currentTime = 0;
          video.play();
          btn.setAttribute('aria-label', 'Geluid uit');
        } else {
          video.muted = true;
          btn.setAttribute('aria-label', 'Geluid aan');
        }
        btn.classList.toggle('is-on', !video.muted);
      });
    });
  }

  function init(root) {
    root = root || document;
    initReveal(root);
    root.querySelectorAll('[data-dn-slider]').forEach(initSlider);
    initVideos(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  // Thema-editor: sectie opnieuw geladen
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
